const LOCAL_TIER = 'local';
const DEV_TIER = 'dev';
const STAGING_TIER = 'staging';
const PRODUCTION_TIER = 'prod';
// set in index.html by CI
const tierSetFromGlobal = process.env.REACT_APP_TIER ?? window.TIER;

export const isRegistrationOpen = true;
const activeYear = 2024;

export const config = ((tier) => {
  if (tier === LOCAL_TIER) {
    return {
      tier,
      activeYear,
      auth0: {
        domain:
          process.env.REACT_APP_AUTH0_DOMAIN ??
          'accounts.staging.sothelabs.com',
        audience:
          process.env.REACT_APP_AUTH0_AUDIENCE ??
          'https://customer.api.stg.sothebys.com',
        client_id:
          process.env.REACT_APP_AUTH0_CLIENT_ID ??
          'vXkbOZlwktY5dbvsEBPems6wfBTevoFv',
        scope: process.env.REACT_APP_AUTH0_SCOPE ?? 'openid profile',
        redirect_uri: window.location.origin,
      },
      clientApiUrl:
        process.env.REACT_APP_CLIENT_API_URL ??
        'https://clientapi.staging.sothelabs.com/graphql',
      apiUrl: process.env.REACT_APP_API_URL ?? 'http://localhost:4000/graphql',
      registerUrl: 'https://staging.sothebys.com/buy/register',
      s3BucketDomain: 'https://napa.staging.sothelabs.com',
    };
  } else if (tier === DEV_TIER) {
    return {
      tier,
      activeYear,
      auth0: {
        domain: 'accounts.staging.sothelabs.com',
        audience: 'https://customer.api.stg.sothebys.com',
        client_id: 'vXkbOZlwktY5dbvsEBPems6wfBTevoFv',
        scope: 'openid profile',
        redirect_uri: window.location.origin,
      },
      clientApiUrl: 'https://clientapi.staging.sothelabs.com/graphql',
      apiUrl: 'https://napa-api.dev.sothelabs.com/graphql',
      registerUrl: 'https://staging.sothebys.com/buy/register',
      s3BucketDomain: 'https://napa.staging.sothelabs.com',
    };
  } else if (tier === STAGING_TIER) {
    return {
      tier,
      activeYear,
      auth0: {
        domain: 'accounts.staging.sothelabs.com',
        audience: 'https://customer.api.stg.sothebys.com',
        client_id: 'vXkbOZlwktY5dbvsEBPems6wfBTevoFv',
        scope: 'openid profile',
        redirect_uri: window.location.origin,
      },
      clientApiUrl: 'https://clientapi.staging.sothelabs.com/graphql',
      apiUrl: 'https://napa-api.staging.sothelabs.com/graphql',
      registerUrl: 'https://staging.sothebys.com/buy/register',
      s3BucketDomain: 'https://napa.staging.sothelabs.com',
    };
  } else if (tier === PRODUCTION_TIER) {
    return {
      tier,
      activeYear,
      auth0: {
        domain: 'accounts.sothebys.com',
        audience: 'https://customer.api.sothebys.com',
        client_id: 'o8da8i9hAiMYjKLxZ0SR0gdZCwRzDmHq',
        scope: 'openid profile',
        redirect_uri: window.location.origin,
      },
      clientApiUrl: 'https://clientapi.prod.sothelabs.com/graphql',
      apiUrl: 'https://napa-api.prod.sothelabs.com/graphql',
      registerUrl: 'https://sothebys.com/buy/register',
      s3BucketDomain: 'https://napa.sothebys.com',
    };
  } else {
    const err = 'Unknown tier: please set REACT_APP_TIER or window.TIER';
    alert(err);
    throw new Error(err);
  }
})(tierSetFromGlobal);
